import { createContext, useContext, useEffect, useState } from 'react'
import { useAuth } from './AuthContext'
import { newsRoutes, notificationsRoutes } from '../routes'
import { useStatus } from './Status.context'
import socket from '../connections/socket.connection'

export const NotificationsContext = createContext()

export const NotificationsProvider = props => {
    const { userData, isAuthenticated } = useAuth()
    const { setstatus } = useStatus()
    const [myNotifications, setMyNotifications] = useState([])
    const [lastNotification, setLastNotification] = useState()
    const [listaLectura, setListaLectura] = useState(false)

    const [noticias, setNoticias] = useState([])
    const [ultimaNoticia, setUltimaNoticia] = useState()

    // Manejo de WebSockets usando la conexión global
    useEffect(() => {
        if (isAuthenticated && userData?._id && socket.socket) {
            const handleNewNotification = (notification) => {
                const roleDbName = userData.role?.dbName || userData.role

                const managementRoles = [
                    'superAdmin',
                    'admin',
                    'sapExecutive',
                    'shiftManager',
                    'chiefMachinery',
                    'OperatorInspector',
                    'OperatorMachineryUniversal'
                ]

                const isForMe = !notification.targetRoles ||
                                notification.targetRoles.length === 0 ||
                                notification.targetRoles.includes(roleDbName) ||
                                (notification.type === 'PASSWORD_RESET' && managementRoles.includes(roleDbName))

                let isSameSite = true
                const isAdmin = roleDbName === 'admin' || roleDbName === 'superAdmin'
                const isUniversal = roleDbName === 'OperatorInspectorUniversal' || roleDbName === 'OperatorMachineryUniversal'

                if (!isAdmin && !isUniversal && (notification.siteId || (notification.siteIds && notification.siteIds.length > 0))) {
                    const mySiteIds = userData.obras?.map(o => {
                        if (!o) return null
                        if (typeof o === 'object') return o._id?.toString()
                        return o.toString()
                    }).filter(Boolean) || []

                    const notificationSiteIds = []
                    if (notification.siteId) {
                        const sId = typeof notification.siteId === 'object' ? notification.siteId._id : notification.siteId
                        if (sId) notificationSiteIds.push(sId.toString())
                    }
                    if (notification.siteIds && Array.isArray(notification.siteIds)) {
                        notification.siteIds.forEach(s => {
                            const sId = typeof s === 'object' ? s._id : s
                            if (sId) notificationSiteIds.push(sId.toString())
                        })
                    }

                    isSameSite = mySiteIds.some(myId => notificationSiteIds.includes(myId))
                }

                if (isForMe && isSameSite) {
                    setMyNotifications(prev => {
                        const index = prev.findIndex(n => n._id === notification._id)
                        if (index !== -1) {
                            const newList = [...prev]
                            newList[index] = notification
                            return newList.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
                        }
                        return [notification, ...prev].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
                    })

                    setstatus({
                        status: 'completed',
                        severity: notification.type === 'PASSWORD_RESET' ? 'warning' : 'info',
                        title: notification.title,
                        message: notification.message
                    })

                    if (notification.type === 'PASSWORD_RESET') {
                        const notifiedIds = JSON.parse(localStorage.getItem('notified_reset_ids') || '[]')
                        if (!notifiedIds.includes(notification._id)) {
                            localStorage.setItem('notified_reset_ids', JSON.stringify([...notifiedIds, notification._id]))
                        }
                    }
                }
            }

            const handleResolvedNotification = (notification) => {
                const roleDbName = userData.role?.dbName || userData.role

                const managementRoles = [
                    'superAdmin',
                    'admin',
                    'sapExecutive',
                    'shiftManager',
                    'chiefMachinery',
                    'OperatorInspector',
                    'OperatorMachineryUniversal'
                ]

                const isForMe = !notification.targetRoles ||
                                notification.targetRoles.length === 0 ||
                                notification.targetRoles.includes(roleDbName) ||
                                (notification.type === 'PASSWORD_RESET' && managementRoles.includes(roleDbName))

                let isSameSite = true
                const isAdmin = roleDbName === 'admin' || roleDbName === 'superAdmin'
                const isUniversal = roleDbName === 'OperatorInspectorUniversal' || roleDbName === 'OperatorMachineryUniversal'

                if (!isAdmin && !isUniversal && (notification.siteId || (notification.siteIds && notification.siteIds.length > 0))) {
                    const mySiteIds = userData.obras?.map(o => {
                        if (!o) return null
                        if (typeof o === 'object') return o._id?.toString()
                        return o.toString()
                    }).filter(Boolean) || []

                    const notificationSiteIds = []
                    if (notification.siteId) {
                        const sId = typeof notification.siteId === 'object' ? notification.siteId._id : notification.siteId
                        if (sId) notificationSiteIds.push(sId.toString())
                    }
                    if (notification.siteIds && Array.isArray(notification.siteIds)) {
                        notification.siteIds.forEach(s => {
                            const sId = typeof s === 'object' ? s._id : s
                            if (sId) notificationSiteIds.push(sId.toString())
                        })
                    }

                    isSameSite = mySiteIds.some(myId => notificationSiteIds.includes(myId))
                }

                if (isForMe && isSameSite) {
                    setMyNotifications(prev => prev.map(n => n._id === notification._id ? notification : n))

                    if (notification.type === 'PASSWORD_RESET') {
                        const revisorName = notification.metadata?.userRevisor
                            ? `${notification.metadata.userRevisor.name} ${notification.metadata.userRevisor.lastName}`
                            : 'Un administrador'
                        const revisorRoleName = notification.metadata?.userRevisor?.role?.name || 'Administrador'

                        const senderName = notification.metadata?.sender
                            ? `${notification.metadata.sender.name} ${notification.metadata.sender.lastName}`
                            : 'un usuario'
                        const senderRoleName = notification.metadata?.sender?.role?.name || 'Operario'

                        setstatus({
                            status: 'completed',
                            severity: 'success',
                            title: 'Solicitud de Contraseña Resuelta',
                            message: `${revisorName} - ${revisorRoleName}, resolvió la contraseña de ${senderName} - ${senderRoleName}`
                        })
                    }
                }
            }

            socket.socket.on('new_notification', handleNewNotification)
            socket.socket.on('resolved_notification', handleResolvedNotification)

            socket.socket.on('new_news', (noticia) => {
                // Actualizar lista de noticias en tiempo real
                setNoticias(prev => {
                    if (prev.find(n => n._id === noticia._id)) return prev
                    const newList = [noticia, ...prev].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
                    setUltimaNoticia(newList[0])
                    return newList
                })

                setstatus({
                    status: 'completed',
                    severity: 'info',
                    title: 'Nueva Noticia',
                    message: noticia.title
                })
            })

            return () => {
                socket.socket.off('new_notification', handleNewNotification)
                socket.socket.off('resolved_notification', handleResolvedNotification)
                socket.socket.off('new_news')
            }
        }
    }, [isAuthenticated, userData])

    useEffect(() => {
        if (userData?._id && isAuthenticated) {
            getNoticias()
            getNotifications()
        }
    }, [userData, isAuthenticated])

    useEffect(() => {
        if (ultimaNoticia && !ultimaNoticia.isRead) {
            const notifiedIds = JSON.parse(localStorage.getItem('notified_news_ids') || '[]')

            if (!notifiedIds.includes(ultimaNoticia._id)) {
                setstatus({
                    status: 'completed',
                    message: `${ultimaNoticia.isVersionNote ? 'Nueva actualización' : 'Nueva noticia'}: ${ultimaNoticia.title}`,
                    title: ultimaNoticia.isVersionNote ? 'Actualización del Sistema' : 'Noticia ICV',
                    severity: ultimaNoticia.isVersionNote ? 'info' : 'success'
                })

                localStorage.setItem('notified_news_ids', JSON.stringify([...notifiedIds, ultimaNoticia._id]))
            }
        }
    }, [ultimaNoticia])

    const orderByDate = (a, b) => {
        return new Date(b.createdAt) - new Date(a.createdAt)
    }

    const getNoticias = async () => {
        if (!userData || !userData._id) {
            console.warn('userData or userData._id is undefined, cannot fetch news.')
            setNoticias([]) // Ensure noticias is an empty array
            setUltimaNoticia(undefined)
            setListaLectura(false)
            return
        }
        const response = await newsRoutes.getMyNews(userData._id)
        // Assuming response.data.data is the correct path for the array of news
        if (response.data && Array.isArray(response.data.data)) {
            setNoticias(response.data.data.sort(orderByDate))
            setUltimaNoticia(response.data.data.sort(orderByDate)[0])
            setListaLectura(true)
        } else {
            console.error('Unexpected response format for news:', response.data)
            setNoticias([]) // Set to empty array to prevent further errors
            setUltimaNoticia(undefined)
            setListaLectura(false)
        }
    }

    const getNotifications = async () => {
        try {
            const response = await notificationsRoutes.getNotifications()
            const sortedNotifications = response.data.sort(orderByDate)
            setMyNotifications(sortedNotifications)

            const lastNotif = sortedNotifications[0]
            setLastNotification(lastNotif)

            // Alertar si hay solicitudes de reset de contraseña nuevas para admins
            const isAdmin = userData?.role?.dbName === 'admin' || userData?.role?.dbName === 'superAdmin'
            if (isAdmin) {
                const pendingReset = sortedNotifications.find(n => n.type === 'PASSWORD_RESET' && !n.isResolved)
                if (pendingReset) {
                    const notifiedIds = JSON.parse(localStorage.getItem('notified_reset_ids') || '[]')
                    if (!notifiedIds.includes(pendingReset._id)) {
                        setstatus({
                            status: 'completed',
                            severity: 'warning',
                            title: 'Solicitud de Contraseña',
                            message: `Hay una solicitud pendiente de ${pendingReset.sender?.name || 'un usuario'}`
                        })
                        localStorage.setItem('notified_reset_ids', JSON.stringify([...notifiedIds, pendingReset._id]))
                    }
                }
            }
        } catch (error) {
            console.error('Error fetching notifications:', error)
        }
    }

    const markNotificationAsRead = async (id) => {
        try {
            await notificationsRoutes.markAsRead(id)
            setMyNotifications(prev => prev.map(n => n._id === id ? { ...n, readBy: [...(n.readBy || []), userData._id] } : n))
        } catch (error) {
            console.error('Error marking notification as read:', error)
        }
    }

    const resolveNotification = async (id) => {
        try {
            const response = await notificationsRoutes.resolve(id)
            const updatedNotification = response.data
            setMyNotifications(prev => prev.map(n => n._id === id ? updatedNotification : n))
            return updatedNotification
        } catch (error) {
            console.error('Error resolving notification:', error)
            throw error
        }
    }

    const marcarNoticiaComoLeidaEnContexto = (noticiaId) => {
        setNoticias(prev => {
            const nuevasNoticias = prev.map(n => n._id === noticiaId ? { ...n, isRead: true } : n)
            // Actualizar también ultimaNoticia si es la que cambió
            if (ultimaNoticia?._id === noticiaId) {
                setUltimaNoticia({ ...ultimaNoticia, isRead: true })
            }
            return nuevasNoticias
        })
    }

    const marcarTodasComoLeidasEnContexto = () => {
        setNoticias(prev => prev.map(n => ({ ...n, isRead: true })))
        if (ultimaNoticia) {
            setUltimaNoticia({ ...ultimaNoticia, isRead: true })
        }
    }

    const provider = {
        myNotifications,
        lastNotification,
        getNotifications,
        markNotificationAsRead,
        resolveNotification,
        noticias,
        ultimaNoticia,
        listaLectura,
        marcarNoticiaComoLeidaEnContexto,
        marcarTodasComoLeidasEnContexto,
        getNoticias
    }

    return (
        <NotificationsContext.Provider value={provider} {...props} />
    )
}

export const useNotificationsContext = () => useContext(NotificationsContext)
